import * as React from 'react'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { Icon, IconType, Container, Text } from 'DVWebNodeUI'
import { ICollection } from '../../selectors/collections'
import { CarouselCollection } from '../carousel/carouselCollection'
import * as stPackshot from '../carousel/carouselCollectionItem.module.scss'
import * as st from './castAndCrew.module.scss'
import * as stUtility from '../utilityClasses.module.scss'
import { SrcSize } from '../../utils/imageUtils'
import { ResponsiveImage } from '../images/responsiveImage'
import { StringId } from '../localizer/stringId'
import { TextLocalizer } from '../localizer/localizer'

const MEMBER_IMAGE_PHONE_LANDSCAPE_WIDTH = 112
const MEMBER_IMAGE_DEFAULT_WIDTH = 175

export interface ICastAndCrewProps {
  content?: WpsRuntime.atv.wps.CastAndCrewWidgetModelProps
}

const CastAndCrewRow = ({castMember, showCastImages}: {
  castMember: WpsRuntime.atv.wps.CastMemberModel,
  showCastImages: boolean,
}) => {
  const collectionsProps = {
    collectionType: castMember.titleCollections.collectionType,
    cardTitleIds: castMember.titleCollections.cards.map(card => card.titleID)
  } as ICollection

  const portraitFallback = <div className={st.noImage} >
    <Icon className={st.sash} use={IconType.LOGO_PRIMEVIDEO} />
  </div>

  const getCastImage = (imageUrl?: string, personPageImageLink?: string) => {
    if (!imageUrl || imageUrl === '\\N') {
      return portraitFallback
    }

    const imgProps = {
      alt: '',
      src: imageUrl,
      baseValue: MEMBER_IMAGE_DEFAULT_WIDTH,
      srcSizes: [
        { 'max-phone-landscape': MEMBER_IMAGE_PHONE_LANDSCAPE_WIDTH },
      ] as SrcSize[]
    }

    return personPageImageLink ?
      <a href={personPageImageLink} className={'personPageImageLink'}><ResponsiveImage {...imgProps}/></a> :
      <ResponsiveImage {...imgProps}/>
  }

  const buildNameString = ( name: string, role?: string ) => role ? `${name} - ${role}` : name


  const { imageUrl, name, role, personPageLink, personPageImageLink } = castMember.cast

  return (
    <>
      <div>
        <h3 className={`${st.name}`}>
          {buildNameString(name, role)}
        </h3>
        {personPageLink && <Text className={st.personPageLink} string={personPageLink} />}
      </div>
      <div className={`${st.imageRow} ${stPackshot.avSimsCarousel} cast-and-crew-member`}>
        {showCastImages && <span className={`${st.castImage}`}>
          {getCastImage(imageUrl, personPageImageLink)}
        </span>}
        <span className={st.carousel}>
          {collectionsProps.cardTitleIds.length > 0 &&
            <CarouselCollection {...collectionsProps} />}
        </span>
      </div>
    </>
  )
}

export const CastAndCrew = ({ content }: ICastAndCrewProps) => {
  const castMemberList = content && content.castAndCrews

  if (castMemberList && castMemberList.length > 0) {
    // Show cast images if any cast has a image
    const showCastImages = castMemberList.some(member => (member.cast.imageUrl && member.cast.imageUrl !== '\\N'))

    return (
      <Container className={`${stUtility.pageSection} cast-and-crew-section`}>
        <h2 className={st.title}><TextLocalizer stringID={StringId.DV_DP_CAST_CREW_HEADING} /></h2>
        {castMemberList.map((castMember, idx) =>
          <CastAndCrewRow castMember={castMember} showCastImages={showCastImages} key={idx} />
        )}
      </Container>
    )
  } else {
    return null
  }
}
